var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.464 2.291 10.05 3.622l8.486 7.986 1.414-1.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.95 10.21-1.414-1.33-8.486 7.986 1.414 1.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.244H0v2h18z"
  }))));
};
export default SvgLeft;